import { VideoAdsOptions } from '@/connatix/connatixAds'
import { CommunicationService } from '@/utils/communication/communicationService'

function dispatchVideoEvent(videoEvent: { name: string; state?: unknown }) {
    CommunicationService.getInstance().broadcast({
        type: '[Video] Video event',
        videoEvent,
    })
}

export function waitForVideoAdsSetup() {
    return new Promise<VideoAdsOptions | undefined>((resolve) => {
        CommunicationService.getInstance().listenOnce<VideoAdsOptions>(
            '[Video] Setup done',
            resolve,
        )
    })
}

export function sendVideoImpressionAction(adId: string, creativeId: string) {
    dispatchVideoEvent({
        name: 'adImpression',
        state: {
            vastParams: {
                lineItemId: adId,
                creativeId,
            },
        },
    })
}

export function sendVideoAction(eventName: string) {
    dispatchVideoEvent({
        name: eventName,
    })
}
